/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prefer-stateless-function */
import React from "react";
import PropTypes from "prop-types";
import LeafletMap from "./LeafletMap";
import RangeSlider from "./RangeSlider";
import LegendBubble from "./LeafletMap/LegendBubble";
import genBubbleScale from "../utils/dataHelpers/bubbleScale";
import { formatCommaZeroDp } from "../utils/dataHelpers/formatters";
import BodyData from "./BodyData";

class Body extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      year: 2016,
      evictionFilings: 0,
    };
  }

  componentDidMount() {
    this.calcTotalEF();
  }

  calcTotalEF = () => {
    const { year } = this.state;
    const { geoData } = this.props.data;
    const { features } = geoData;
    const evicFilingsAccessor = `ef-${year.toString().slice(-2)}`;
    const evictionFilings = features.reduce((accum, feature) => {
      const { properties } = feature;
      const total = accum + +properties[evicFilingsAccessor];
      return total;
    }, 0);
    this.setState({ evictionFilings });
  };

  updateYear = (year) => {
    this.calcTotalEF();
    this.setState({
      year,
    });
  };

  render() {
    const { data } = this.props;
    const { geoData, iconData } = data;
    const { year, evictionFilings } = this.state;
    const evictionFilingsClean = formatCommaZeroDp(evictionFilings);
    const bubbleScale = genBubbleScale();
    const bodyData = [
      { label: "Year", value: year },
      { label: "Total eviction filings", value: evictionFilingsClean },
      {
        label: "Eviction filing rate",
        value: <LegendBubble bubbleScale={bubbleScale} />,
      },
    ];
    return (
      <div className="body__container">
        <RangeSlider
          minRange={2006}
          maxRange={2016}
          updateYear={this.updateYear}
        />
        <LeafletMap geoData={geoData} iconData={iconData} sliderValue={year} />
        <BodyData data={bodyData} />
      </div>
    );
  }
}

Body.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Body;
